import * as React from 'react';
import Box from '@mui/material/Box';
import { FilterSelect } from './FilterSelect';

type ListFilterPropsLabels = {
    orderStatus: (displayName: string) => string;
    filter: {
        orderStatus: string;
        optionAll: string;
    };
};

type ListFiltersProps = {
    availableOrderStatuses: { id: number; name: string }[];
    labels: ListFilterPropsLabels;
    onChangeOrderStatus: (event: React.ChangeEvent<HTMLInputElement>) => void;
    selectedOrderStatus: number;
};

export function ListFilters({
    availableOrderStatuses,
    onChangeOrderStatus,
    selectedOrderStatus,
    labels
}: ListFiltersProps) {
    let translatedFilterOptions = availableOrderStatuses.map(({ id, name }) => ({
        id,
        name: labels.orderStatus(name)
    }));

    return (
        <Box>
            <FilterSelect
                label={labels.filter.orderStatus}
                optionAllLabel={labels.filter.optionAll}
                options={translatedFilterOptions}
                onChange={onChangeOrderStatus}
                value={selectedOrderStatus}
            />
        </Box>
    );
}
